var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent" },
    [
      _c("dialogue", {
        attrs: {
          title: "Success",
          paragraph: _vm.save_dialogue_text,
          button_names: ["Accept", "Copy"],
          show: _vm.save_dialogue,
          autoClose: false
        },
        on: { dialogue: _vm.saveDialogue, cancel: _vm.saveDialogueCancel }
      }),
      _vm._v(" "),
      _c("dialogue", {
        attrs: {
          title: "Error",
          paragraph: _vm.error_dialogue_text,
          button_names: ["Accept"],
          show: _vm.error_dialogue
        },
        on: { cancel: _vm.errorDialogue }
      }),
      _vm._v(" "),
      _c("div", [
        _vm.term == undefined
          ? _c("p", { staticStyle: { "font-size": "45px", margin: "10px" } }, [
              _vm._v(_vm._s(_vm.title))
            ])
          : _c("p", { staticStyle: { "font-size": "45px", margin: "10px" } }, [
              _vm._v(_vm._s(_vm.title + ": " + _vm.term))
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "scroll",
          style: _vm.navbar ? "margin-bottom:50px" : "margin-bottom:10px"
        },
        [
          _c(
            "table",
            { staticStyle: { position: "relative", "z-index": "1" } },
            _vm._l(_vm.add_names, function(column, index) {
              return _c(
                "tr",
                [
                  _vm.add_names[index].substr(
                    _vm.add_names[index].length - 4
                  ) == "Time"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.add_names[index]) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("datetime", {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.table_data[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.table_data, index, $$v)
                                },
                                expression: "table_data[index]"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index].substr(
                        _vm.add_names[index].length - 5
                      ) == "Times"
                    ? [
                        _vm.job_type == "5• AAA,6• AAD" ||
                        _vm.job_type == "9• COM,6• AAD"
                          ? [
                              _c("td", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.add_names[index].slice(0, -1)) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("datetime", {
                                    staticStyle: { width: "100%" },
                                    model: {
                                      value: _vm.table_data[index],
                                      callback: function($$v) {
                                        _vm.$set(_vm.table_data, index, $$v)
                                      },
                                      expression: "table_data[index]"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", { staticClass: "empty" })
                            ]
                      ]
                    : _vm.add_names[index] == "JobType"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.add_names[index]) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("jobtype", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                index: index,
                                search: _vm.table_data[index],
                                use_radio: _vm.use_radio
                              },
                              on: { input: _vm.setJobType }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index] == "RadioStatus"
                    ? [
                        _c("td", [
                          _vm._v("\n\t\t\t\t\t\t\tStatus\n\t\t\t\t\t\t")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("status", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                index: index,
                                status: _vm.table_data[index]
                              },
                              on: { input: _vm.setStatus }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index] == "Side"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.add_names[index]) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("autocomplete", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                list: ["Starboard", "Port"],
                                type: _vm.add_types[index]
                              },
                              model: {
                                value: _vm.table_data[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.table_data, index, $$v)
                                },
                                expression: "table_data[index]"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index] == "_Status"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.add_names[index].substr(
                                  1,
                                  _vm.add_names[index].length - 1
                                )
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("autocomplete", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                list: [
                                  "Open",
                                  "Completed",
                                  "Cancelled",
                                  "Internal"
                                ],
                                type: _vm.add_types[index]
                              },
                              model: {
                                value: _vm.table_data[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.table_data, index, $$v)
                                },
                                expression: "table_data[index]"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index] == "Status"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.add_names[index]) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("autocomplete", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                list: ["Unassigned", "Assigned"],
                                type: _vm.add_types[index]
                              },
                              model: {
                                value: _vm.table_data[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.table_data, index, $$v)
                                },
                                expression: "table_data[index]"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.add_names[index].substr(0, 1) == "_"
                    ? [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.add_names[index].substr(
                                  1,
                                  _vm.add_names[index].length - 1
                                )
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.table_data[index],
                                expression: "table_data[index]"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            domProps: { value: _vm.table_data[index] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.table_data,
                                  index,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    : [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.add_names[index]) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("autocomplete", {
                              staticStyle: { width: "100%" },
                              attrs: { type: _vm.add_types[index] },
                              model: {
                                value: _vm.table_data[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.table_data, index, $$v)
                                },
                                expression: "table_data[index]"
                              }
                            })
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _c(
            "button",
            {
              attrs: { disabled: _vm.button_disabled },
              on: {
                click: function($event) {
                  return _vm.cancel()
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "button",
            {
              attrs: { disabled: _vm.button_disabled },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v("Save")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d04f7908", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d04f7908","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_2.vue
// module id = 742
// module chunks = 0